import React from 'react'
import './Nav.css'
import { Link } from 'react-router'
import { stack as Menu } from 'react-burger-menu'
import { useLocation } from 'react-router'

type NavProps = {}

export const Nav = ({}: NavProps) => {
  const location = useLocation()
  const [menuOpen, setMenuOpen] = React.useState(false)

  const closeMenu = () => {
    setMenuOpen(false)
  }

  const openMenu = () => {
    setMenuOpen(true)
  }
  
  return(
  <div className='navContainer'>
    <div className='navFlex'>
      <div className='navHeader'>
          <h1>Alirie Gray</h1>
          <p className='subtitle'>Gameplay programmer</p>
      </div>
      <div className='navBar'>
        <div className='burger'>
          <Menu isOpen={menuOpen} onOpen={openMenu} onClose={closeMenu} right width={'200px'}>
            <Link className={location.pathname==='/games' || location.pathname==='/' ? 'activeBurger':'' } onClick={() => closeMenu()} to="/games">Games</Link>
            <Link onClick={() => closeMenu} to="https://alirie.itch.io/" target="_blank" rel="noopener noreferrer">Student Games</Link>
            <Link className={location.pathname==='/about' ? 'activeBurger':'' } onClick={() => closeMenu()} to="/about">About Me</Link>
            <a href="/Alirie_Gray_Resume.pdf" download>Resume</a>
          </Menu>
        </div>
        <div className='links'>
          <Link className={location.pathname==='/games' || location.pathname==='/' ? 'active':'' } to="/games">Games</Link>
          <Link onClick={() => closeMenu} to="https://alirie.itch.io/" target="_blank" rel="noopener noreferrer">Student Games</Link>
          <Link className={location.pathname==='/about'? 'active':'' } to="/about">About Me</Link>
          <Link className={location.pathname==='/resume' ? 'active':'' } to="/resume">Resume</Link>
        </div>
      </div>
    </div>
  </div>
)}